import React, { useContext, useEffect, useRef, useState } from "react";
import {
  DocumentDuplicateIcon,
  DocumentIcon,
  DocumentTextIcon,
  PencilIcon,
  PlusIcon,
  PrinterIcon,
  TrashIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import toast from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import * as XLSX from "xlsx"; // xlsx: for exporting excel file. Use xlsx to convert the table data into Excel format and trigger the download.

import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import { SiMicrosoftexcel } from "react-icons/si";
import { FaFilePdf } from "react-icons/fa6";
import { ImPrinter } from "react-icons/im";
import { FaCopy } from "react-icons/fa6";
import { Spinner } from "../../../Reusable/Spinner";
import { UserContext } from "../../../Context/UserContext";
import { BaseURL } from "../../../Reusable/BaseURL";
import MyInput from "../../../Reusable/MyInput";
import { ViewEnquiryTableSkeleton } from "../../../Reusable/skeleton/ViewEnquiryTableSkeleton";

export default function CompareQuotationPageForm({
  editBtn,
  // firstPageList,
  links,
  firstPage,
  setFirstPage,
  setGetId,
  spinner,
  totalNo,
  from,
  to,
  addMoreToggle,
  setAddMoreToggle,
  getUnsavedItemList,
  negoAmountTotal,
  setNegoAmountTotal,
}) {
  const { darkTheme, loginData } = useContext(UserContext);

  const [searchInp, setSearchInp] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [searchTotalNo, setSearchTotalNo] = useState(0);
  const [searchFrom, setSearchFrom] = useState(0);
  const [searchTo, setSearchTo] = useState(0);
  const [view, setView] = useState([]);
  const [searchSpinner, setSearchSpinner] = useState(true);

  // const [quotedUnitRate, setQuotedUnitRate] = useState("")
  // const [quotedAmount, setQuotedAmount] = useState("")
  // const [discount, setDiscount] = useState("")
  // const [finalAmount, setFinalAmount] = useState("")
  // const [negotiationRate, setNegotiationRate] = useState("")
  // const [negotiationAmount, setNegotiationAmount] = useState("")

  const myFormData = {
    quotedUnitRate: "",
    quotedAmount: "",
    discount: "",
    finalAmount: "",
    negotiationRate: "",
    negotiationAmount: "",
  };
  const [inputDatas, setInputDatas] = useState([myFormData]);

  const inputHandler = (index, value, inputName, itemQty) => {
    setFirstPage((prev) => {
      const data = [...prev];
      data[index][inputName] = value;
      data[index] = { ...data[index], inputName: value };

      // const amount = data[index].quoted_unit_rate * itemQty;
      // const famount = amount - data[index].discount;
      // const namount = data[index].negotiation_rate * itemQty;

      data[index] = {
        ...data[index],
        quoted_amount: data[index].quoted_unit_rate * itemQty,
        final_amount:
          data[index].quoted_unit_rate * itemQty - data[index].discount,
        negotiation_amount: data[index].negotiation_rate * itemQty,
      };

      let negotiationTotal = 0;
      data.forEach((item, index) => {
        negotiationTotal += item.negotiation_amount;
      });
      setNegoAmountTotal(negotiationTotal);

      return data;
    });
  };
  console.log({ firstPage });

  useEffect(() => {
    // divisionList()
    // firstPageList();
  }, []);

  // function divisionList(){
  //   fetch(`${BaseURL}/divisions`,{
  //     method: "GET",
  //     headers:{
  //       Accept: "application/json",
  //       Authorization: `Bearer ${loginData.token}`
  //     }
  //   }).then(res=> res.json())
  //   .then(li=> {
  //     if(li?.status){
  //       setView(li.data.data);
  //     }
  //   });
  // }

  // CONFIRM ALERT FOR DELETE A RECORD=================
  function deleteARecord(id) {
    const options = {
      // title: "Are you sure?",
      message: "You want to delete this record?",
      buttons: [
        {
          label: "Yes",
          onClick: () => deleteConfirm(),
        },
        {
          label: "No",
          // onClick: () => alert('Click No')
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      willUnmount: () => {},
      afterClose: () => {},
      onClickOutside: () => {},
      onKeypress: () => {},
      onKeypressEscape: () => {},
      overlayClassName: "overlay-custom-class-name",
    };
    async function deleteConfirm() {
      await fetch(`${BaseURL}/purchase/indent/deletecacheitem/${id}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      })
        .then((resjson) => resjson.json())
        .then((deleteRes) => {
          // firstPageList();
          toast.success("Deleted!");
        });
    }
    confirmAlert(options);
  }

  function searchList(searchValue) {
    setSearchSpinner(true);
    fetch(`${BaseURL}/divisions?q=${searchValue}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${loginData.token}`,
      },
    })
      .then((res) => res.json())
      .then((search) => {
        setSearchData(search.data.data);
        setSearchTotalNo(search.total);
        setSearchFrom(search.from);
        setSearchTo(search.to);
        setSearchSpinner(false);
      });
  }

  // COPY TO CLIPBOARD
  const copyToClipboard = () => {
    let data = "S.No.\tName\n";
    if (firstPage.length > 0 && searchInp === "") {
      firstPage.forEach((row, index) => {
        data += `${index + 1}\t${row.name}\n`;
      });
    } else if (searchInp !== "" && searchInp.length > 0) {
      searchData.forEach((row, index) => {
        data += `${index + 1}\t${row.name}\n`;
      });
    }

    navigator.clipboard.writeText(data).then(
      () => {
        toast.success("Table data copied to clipboard");
      },
      (err) => {
        // console.error('Could not copy text: ', err);
        toast.error("Could not copy text");
      }
    );
  };

  // DOWNLOAD EXCEL BTN
  const exportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet from the table data
    const ws = XLSX.utils.json_to_sheet(firstPage);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    // Generate Excel file and trigger download
    XLSX.writeFile(wb, "Division_table_data_excel.xlsx");
  };

  // // PRINT BTN
  // const PrintTable = () => {
  //   const printContents = document.getElementById('tablePrn').outerHTML;
  //   const originalContents = document.body.innerHTML;

  //   document.body.innerHTML = printContents;
  //   window.print();
  //   document.body.innerHTML = originalContents;
  // };

  // PDF/Print BTN-download
  const tableRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => tableRef.current,
  });

  const handleDownloadPdf = async () => {
    const element = tableRef.current;
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    pdf.addImage(imgData, "PNG", 0, 0);
    pdf.save("Division_table_pdf.pdf");
  };
  //close - pdf btn download

  // MODIFY PREVIOUS & NEXT BTN
  // const previousBtn = links[0].replace("&laquo; ", "<");
  // let endPostn = links.length-1;
  // let nextBtn = links[endPostn];
  // nextBtn.replace(" &raquo;", "<")
  // console.log("nextBtn", nextBtn);

  return (
    <div>
      {/* TABLE DOWNLOAD BTNs */}
      {/* <div className="mb-2">
        <div className="flex items-center justify-between flex-wrap gap-2">
          <div>
            <MyInput
              value={searchInp}
              onInput={(e) => {
                setSearchInp(e.target.value);
                searchList(e.target.value);
              }}
              placeholder="Auto Search.."
              type="text"
              className="w-[260px]"
            />
          </div>
          <div className="flex gap-1">
            <Button
              className="py-1 px-[10px]"
              title="Copy"
              onClick={copyToClipboard}
            >
              <FaCopy className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-green-700"
              title="Excel"
              onClick={exportToExcel}
            >
              <SiMicrosoftexcel className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-red-600"
              title="PDF"
              onClick={() => handleDownloadPdf()}
            >
              <FaFilePdf className="w-4 h-4" />
            </Button>
            <Button
              className="py-1 px-[10px] bg-[#6d6e70]"
              title="Print"
              onClick={() => handlePrint()}
            >
              <ImPrinter className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div> */}

      {/* TABLE-RECORDS */}

      {/* <div className="flex items-center justify-center mb-1">
        <div
          className="!py-1 px-[16px] bg-[#7F181B] text-white"
          onClick={() => setAddMoreToggle(!addMoreToggle)}
        >
          Party Quotation List
        </div>
      </div> */}

      {/* PARTY QUOTATIONS LIST========
      =================================  */}
      {firstPage.length > 0 ? (
        firstPage.map((partyQuotation, index) => (
          // =========

          <div
            ref={tableRef}
            // className="scrollBar relative overflow-x-auto shadow-md sm:rounded-lg"
            className="scrollBar relative overflow-x-auto overflow-y-auto sm:rounded-lg h-auto max-h-[800px] mb-6 border-b-4 border-b-[#8CDDCD]"
            key={index}
          >
            <div className="flex gap-2 flex-wrap bg-[#8CDDCD] px-2 py-0.5 w-screen rounded-tr-lg">
              <span className="bg-white px-0.5 rounded font-extrabold text-[16px]">
                {partyQuotation?.grade ? `L-${partyQuotation.grade}` : ""}
              </span>
              <span className="bg-white px-0.5 rounded">
                Party Name: {partyQuotation.party.name}
              </span>
              <span className="bg-white px-0.5 rounded">
                GST No. {partyQuotation.party.gst_no}
              </span>
              <span className="font-bold bg-white px-0.5 rounded">
                Quotation Amount. {partyQuotation.quotation_sum_amount}
              </span>
            </div>
            <table
              id="tablePrn"
              className={`w-full text-[11px] uppercase text-left rtl:text-right ${
                darkTheme
                  ? "text-gray-500 bg-slate-200"
                  : "text-gray-400 bg-slate-100"
              }`}
            >
              <thead
                className={`${
                  darkTheme
                    ? "bg-gray-700 text-gray-400"
                    : "bg-gray-50 text-gray-700"
                }`}
              >
                <tr>
                  {/* <th className="px-3 py-3">Action</th> */}
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      U.Rate
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Amount
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Disc
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      F.Amount
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Nego.Rate
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Nego.Amt
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Division
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Category
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Material T
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      HSN No.
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      HSN GST%
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Itm.C
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Item Name
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Itm.Short N
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Brand
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Unit
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      Qty
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                  <th scope="col" className="px-2 py-1">
                    <div className="flex items-center">
                      S.No.
                      <a href="#">
                        <svg
                          className="w-3 h-3 ms-1.5"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                        </svg>
                      </a>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {searchInp !== "" ? (
                  searchData.length > 0 ? (
                    <>
                      {searchData.map((item, index) => (
                        <tr
                          key={index}
                          className={`border-b ${
                            darkTheme
                              ? "bg-gray-800 border-gray-700"
                              : "bg-white "
                          }`}
                        >
                          {/* <td scope="col" className="px-3 py-3">
                        <div className="flex items-center gap-2">
                          <PencilIcon
                            onClick={() => {
                              editBtn(item.id);
                              setGetId(item.id);
                            }}
                            className={
                              "w-4 h-4 font-medium " +
                              (darkTheme
                                ? "text-blue-500 hover:text-blue-400"
                                : "text-blue-600 hover:text-blue-500")
                            }
                          />
                          <TrashIcon
                            onClick={() => {
                              deleteARecord(item.id);
                            }}
                            className={
                              "w-4 h-4 font-medium " +
                              (darkTheme
                                ? "text-blue-500 hover:text-blue-400"
                                : "text-red-500 hover:text-red-400")
                            }
                          />
                        </div>
                      </td> */}
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {index + 1}
                          </td>
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {item.division}
                          </td>
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {item.item_name}
                          </td>
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {item.brand_name}
                          </td>
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {item.unit}
                          </td>
                          <td
                            scope="row"
                            className="px-3 py-2 whitespace-nowrap"
                          >
                            {item.qty}
                          </td>
                          {/* <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Quoted Unit Rate"
                          // value={item.quoted_unit_rate}
                          value={quotedUnitRate}
                          onChange={(e)=> setQuotedUnitRate(e.target.value)}
                          className="!py-0.5"
                        />
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Quoted Amount"
                          // value={item.quoted_amount}
                          value={quotedAmount}
                          onChange={(e)=> setQuotedAmount(e.target.value)}
                          className="!py-0.5"
                          disabled = {quotedUnitRate ? false : true}
                        />
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Discount"
                          // value={item.discount}
                          value={discount}
                          onChange={(e)=> setDiscount(e.target.value)}
                          className="!py-0.5"
                        />
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Final Amount"
                          // value={item.final_amount}
                          value={finalAmount}
                          onChange={(e)=> setFinalAmount(e.target.value)}
                          className="!py-0.5"
                          disabled = {discount ? false : true}
                        />
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Negotiation Rate"
                          // value={item.negotiation_rate}
                          value={negotiationRate}
                          onChange={(e)=> setNegotiationRate(e.target.value)}
                          className="!py-0.5"
                        />
                      </td>
                      <td scope="row" className="px-3 py-2 whitespace-nowrap">
                        <MyInput
                          placeholder="Negotiation Amount"
                          // value={item.negotiation_amount}
                          value={negotiationAmount}
                          onChange={(e)=> setNegotiationAmount(e.target.value)}
                          className="!py-0.5"
                          disabled = {negotiationRate ? false : true}
                        />
                      </td> */}
                        </tr>
                      ))}
                    </>
                  ) : spinner ? (
                    <tr
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      <th className="px-3 py-1 text-center" colSpan={3}>
                        <Spinner loading={searchSpinner} />
                      </th>
                    </tr>
                  ) : (
                    <tr
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      <th
                        className="px-3 py-1 text-red-500 text-center"
                        colSpan={3}
                      >
                        No record
                      </th>
                    </tr>
                  )
                ) : partyQuotation.quotation_items.length > 0 ? (
                  partyQuotation.quotation_items.map((item, index) => (
                    <tr
                      key={index}
                      className={`border-b ${
                        darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                      }`}
                    >
                      {/* <td scope="col" className="px-3 py-3">
                    <div className="flex items-center gap-2">
                      <PencilIcon
                        onClick={() => {
                          setGetId(item.id);
                          editBtn(item.id);
                        }}
                        className={
                          "w-4 h-4 font-medium " +
                          (darkTheme
                            ? "text-blue-500 hover:text-blue-400"
                            : "text-blue-600 hover:text-blue-500")
                        }
                      />
                      <TrashIcon
                        onClick={() => {
                          deleteARecord(item.id);
                        }}
                        className={
                          "w-4 h-4 font-medium " +
                          (darkTheme
                            ? "text-blue-500 hover:text-blue-400"
                            : "text-red-500 hover:text-red-400")
                        }
                      />
                    </div>
                  </td> */}

                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.quoted_unit_rate}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.quoted_amount}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.discount}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.final_amount}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.negotiation_rate}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.negotiation_amount}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.division}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.category}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.material_type}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.hsn_no}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.hsn_gst_percent}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.item_code}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.item_name}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.item_short_name}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.brand}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.unit}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {item.indent_item.qty}
                      </td>
                      <td scope="row" className="px-2 py-0.5 whitespace-nowrap">
                        {index + 1}
                      </td>
                    </tr>
                  ))
                ) : spinner ? (
                  <tr
                    className={`border-b ${
                      darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                    }`}
                  >
                    <th className="px-3 py-1 text-center" colSpan={3}>
                      <Spinner loading={spinner} />
                    </th>
                  </tr>
                ) : (
                  <tr
                    className={`border-b ${
                      darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                    }`}
                  >
                    <th
                      className="px-3 py-1 text-red-500 text-center"
                      colSpan={3}
                    >
                      No record
                    </th>
                  </tr>
                )}
              </tbody>
              {/* <tfoot>
                <tr
                  className={`border-b ${
                    darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
                  }`}
                >
                  <th className="px-3 py-1"></th>
                  <th className="px-2 py-1">Quoted Unit Rate</th>
                  <th className="px-2 py-1">Quoted Amount</th>
                  <th className="px-2 py-1">Discount</th>
                  <th className="px-2 py-1">Final Amount</th>
                  <th className="px-2 py-1">Negotiation Rate</th>
                  <th className="px-2 py-1">Negotiation Amount</th>
                  <th className="px-2 py-1">Division</th>
                  <th className="px-2 py-1">Category</th>
                  <th className="px-2 py-1">Material Type</th>
                  <th className="px-2 py-1">HSN No.</th>
                  <th className="px-2 py-1">HSN GST %</th>
                  <th className="px-2 py-1">Item Code</th>
                  <th className="px-2 py-1">Item Name</th>
                  <th className="px-2 py-1">Item Short Name</th>
                  <th className="px-2 py-1">Brand</th>
                  <th className="px-2 py-1">Unit</th>
                  <th className="px-2 py-1">Quantity</th>
                  <th className="px-2 py-1">S.No.</th>
                </tr>
              </tfoot> */}
            </table>
            {/* <div
          className={`flex gap-1 items-center justify-between px-2 py-2 text-[12px]`}
        >
          <div>
            Showing {searchFrom !== 0 ? searchFrom : from} to{" "}
            {searchTo !== 0 ? searchTo : to} of{" "}
            {searchTotalNo !== 0 ? searchTotalNo : totalNo}-entries
          </div>
          <div className="flex gap-1 items-center overflow-x-auto scrollBar">
            {links.length > 0 &&
              links.map((item, index) => (
                <button
                  key={index}
                  onClick={() => firstPageList(item.url)}
                  className={`py-[2px] px-[10px] md:py-1 md:px-2 text-[13px] rounded-xl ${
                    item.active && "bg-blue-200 cursor-not-allowed"
                  } ${darkTheme && item.active && "bg-blue-500"}`}
                >
                  {index === 0 ? (
                    <>{item.label.replace("&laquo; Previous", "<")}</>
                  ) : index === links.length - 1 ? (
                    <>{item.label.replace("Next &raquo;", ">")}</>
                  ) : (
                    <>{item.label}</>
                  )}
                </button>
              ))}
          </div>
        </div> */}
          </div>
        ))
      ) : spinner ? (
        // <tr
        //   className={`border-b ${
        //     darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
        //   }`}
        // >
        //   <th className="px-3 py-1 text-center" colSpan={3}>
        //     <Spinner loading={spinner} />
        //   </th>
        // </tr>
        <>
          <ViewEnquiryTableSkeleton rows={3} columns={7} />
          <ViewEnquiryTableSkeleton rows={3} columns={7} />
        </>
      ) : (
        <tr
          className={`border-b ${
            darkTheme ? "bg-gray-800 border-gray-700" : "bg-white "
          }`}
        >
          <th className="px-3 py-1 text-red-500 text-center" colSpan={3}>
            No record
          </th>
        </tr>
      )}
    </div>
  );
}
